export default __webpack_public_path__ + "static/media/flop-equity-rangevsrange_0005_thumb.5a6dfd43.jpg";